import routeNames from "../router/route-names";
export default {
  methods: {
    successRedirect(action, viewData, onlyLogoHeader = false) {
      this.$router.push({
        name: routeNames.SUCCESS_VIEW,
        params: { action, viewData, onlyLogoHeader },
      });
    },
    successSignUpRedirect(action, viewData, onlyLogoHeader) {
      this.$router.push({
        name: routeNames.SUCCESS_VIEW_SIGN_UP,
        params: { action, viewData, onlyLogoHeader },
      });
    },
  },
};
